import { getCookie, setCookie, deleteCookie } from '../../mixins/cookie';

const popupWrapper = document.querySelector( '.wcbt-maxsale-wrapper' );
const wcbtMaxSalePopup = () => {
	if ( ! popupWrapper ) {
		return;
	}

	const popupContent = popupWrapper.querySelector( '.wcbt-maxsale-content' );
	const closeBtn = popupWrapper.querySelector( '.button-close' );
	const status = getCookie( 'wcbt_maxsale' );
	document.addEventListener( 'click', function( event ) {
		const target = event.target;
		if ( closeBtn.contains( target ) || ! popupContent.contains( target ) ) {
			if ( status !== 'close' ) {
				popupWrapper.classList.add( 'hide' );
				if ( WCBT_MAXSALE_OBJECT.repeat_open === 'on' ) {
					setCookie( 'wcbt_maxsale', 'close', 0, WCBT_MAXSALE_OBJECT.repeat_open_time );
				} else {
					setCookie( 'wcbt_maxsale', 'close', 9999999999 );
				}
			}
		}
	} );
};

export default wcbtMaxSalePopup;

